import { type PortableTextComponentProps } from '@portabletext/react'

import { type SanityFrameBuilderImage } from '@frame-builder/data/sanity/queries/types/image'

import Photo from '@frame-builder/components/utility/photo'

type FigureValue = SanityFrameBuilderImage

const Figure = ({ value }: PortableTextComponentProps<FigureValue>) => {
  return <Photo image={value} />
}

export default Figure
